import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IExhibitorQutationRFQStatsPayloadState } from '@app-store/slices/companyStatistics/exhibitorQutationRFQStats'

interface TaskAction extends Action {
    payload: IExhibitorQutationRFQStatsPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.companyStatistics.exhibitorQutationRFQStats

function* exhibitorQutationRFQStatsSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/stats/exhibitor/quotation-rfq`)
        if (response.success) {
            yield put(onSuccess(response.result.data))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* exhibitorQutationRFQStatsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, exhibitorQutationRFQStatsSagaTask)
}

export default exhibitorQutationRFQStatsSaga
